<template>
	<div>
		<h1>{{ value.values.last }} <small v-html="units"></small></h1>
		<p class="row">
			<b>{{ $t('labels.general.min') }}</b>
			<span>{{ min }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.max') }}</b>
			<span>{{ max }} <span v-html="units"></span></span>
		</p>
		<p class="row" v-if="avg">
			<b>{{ $t('labels.general.average') }}</b>
			<span>{{ avg }} <span v-html="units"></span></span>
		</p>
		<p class="row" v-if="stdDev">
			<b>{{ $t('labels.general.standard_deviation') }}</b>
			<span>{{ stdDev }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.samples') }}</b>
			<span>{{ samples }}</span>
		</p>
		<!--pre>{{ value }}</pre-->
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'value'
	],
	computed: {
		units () {
			return Readings.readingTypes.get(parseInt(this.value.type_id)).unitHtml
		},
		min () {
			return this.value.values.min ? this.value.values.min : `${this.value.values.systolic_min} ${this.value.values.diastolic_min}`
		},
		max () {
			return this.value.values.max ? this.value.values.max : `${this.value.values.systolic_max} ${this.value.values.diastolic_max}`
		},
		avg () {
			return this.value.values.avg ? this.value.values.avg : 'n/a'
		},
		stdDev () {
			return this.value.values.std_dev ? this.value.values.std_dev : 'n/a'
		},
		samples () {
			return this.value.values.samples ? this.value.values.samples : 'n/a'
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxBiometricGeneric.vue